{
  "AGENT_MGMT": {
    "HEADER": "ஏஜென்ட்கள்",
    "HEADER_BTN_TXT": "ஏஜென்ட்களைச் சேர்க்க",
    "LOADING": "ஏஜென்ட் பட்டியலைப் பெறபடுகிறது",
    "DESCRIPTION": "An agent is a member of your customer support team who can view and respond to user messages. The list below shows all the agents in your account.",
    "LEARN_MORE": "Learn about user roles",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "நிர்வாகி",
      "AGENT": "ஏஜென்ட்"
    },
    "COUNT": "{n} agent | {n} agents",
    "LIST": {
      "404": "இந்த கணக்குடன் எந்த ஏஜென்ட்டும் இல்லை",
      "TITLE": "உங்கள் அணியில் ஏஜென்ட்களை நிர்வகிக்கவும்",
      "DESC": "உங்கள் அணியில் / ஏஜென்ட்களை நீங்கள் சேர்க்கலாம் / அகற்றலாம்.",
      "NAME": "பெயர்",
      "EMAIL": "ஈ-மெயில்",
      "STATUS": "நிலை",
      "ACTIONS": "செயல்கள்",
      "VERIFIED": "சரிபார்க்கப்பட்டது",
      "VERIFICATION_PENDING": "சரிபார்ப்பு நிலுவையில் உள்ளது",
      "AVAILABLE_CUSTOM_ROLE": "Available custom role permissions"
    },
    "ADD": {
      "TITLE": "உங்கள் குழுவில் ஏஜெண்டைச் சேர்க்கவும்",
      "DESC": "உங்கள் இன்பாக்ஸிற்கான சேவையைக் கையாளக்கூடியவர்களை நீங்களே சேர்க்கலாம்.",
      "CANCEL_BUTTON_TEXT": "ரத்துசெய்",
      "FORM": {
        "NAME": {
          "LABEL": "ஏஜென்ட் பெயர்",
          "PLACEHOLDER": "ஏஜென்ட்ன் பெயரை உள்ளிடவும்"
        },
        "AGENT_TYPE": {
          "LABEL": "ஏஜென்ட் வகை",
          "PLACEHOLDER": "தயவுசெய்து ஒரு வகையைத் தேர்ந்தெடுக்கவும்",
          "ERROR": "ஏஜென்ட் வகை தேவையானது"
        },
        "EMAIL": {
          "LABEL": "ஈ-மெயில் முகவரி",
          "PLACEHOLDER": "ஏஜெண்டின் ஈ-மெயில் முகவரியை உள்ளிடவும்"
        },
        "SUBMIT": "ஏஜென்ட்களைச் சேர்க்க"
      },
      "API": {
        "SUCCESS_MESSAGE": "ஏஜென்ட் வெற்றிகரமாக சேர்க்கப்பட்டார்",
        "EXIST_MESSAGE": "ஏஜென்ட் வெற்றிகரமாக சேர்க்கப்பட்டார்",
        "ERROR_MESSAGE": "வூட் சர்வருடன் இணைக்க முடியவில்ல, மீண்டும் முயற்சிக்கவும்"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Delete",
      "API": {
        "SUCCESS_MESSAGE": "ஏஜென்ட் வெற்றிகரமாக நீக்கப்பட்டார்",
        "ERROR_MESSAGE": "வூட் சர்வருடன் இணைக்க முடியவில்ல, மீண்டும் முயற்சிக்கவும்"
      },
      "CONFIRM": {
        "TITLE": "நீக்குதலை உறுதிப்படுத்தவும்",
        "MESSAGE": "நீக்குவதில் உறுதியாக உள்ளீர்களா ",
        "YES": "ஆம், நீக்கு ",
        "NO": "இல்லை, வைத்திரு "
      }
    },
    "EDIT": {
      "TITLE": "ஏஜெண்டில் திருத்து",
      "FORM": {
        "NAME": {
          "LABEL": "ஏஜென்ட் பெயர்",
          "PLACEHOLDER": "ஏஜென்ட்ன் பெயரை உள்ளிடவும்"
        },
        "AGENT_TYPE": {
          "LABEL": "ஏஜென்ட் வகை",
          "PLACEHOLDER": "தயவுசெய்து ஒரு வகையைத் தேர்ந்தெடுக்கவும்",
          "ERROR": "ஏஜென்ட் வகை தேவையானது"
        },
        "EMAIL": {
          "LABEL": "ஈ-மெயில் முகவரி",
          "PLACEHOLDER": "ஏஜெண்டின் ஈ-மெயில் முகவரியை உள்ளிடவும்"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Availability",
          "PLACEHOLDER": "Please select an availability status",
          "ERROR": "Availability is required"
        },
        "SUBMIT": "ஏஜெண்டில் திருத்து"
      },
      "BUTTON_TEXT": "திருத்து",
      "CANCEL_BUTTON_TEXT": "ரத்துசெய்",
      "API": {
        "SUCCESS_MESSAGE": "ஏஜென்ட் வெற்றிகரமாக புதுப்பிக்கப்பட்டார்",
        "ERROR_MESSAGE": "வூட் சர்வருடன் இணைக்க முடியவில்ல, மீண்டும் முயற்சிக்கவும்"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "பாஸ்வேர்ட்டை மீட்டமைக்கவும்",
        "ADMIN_SUCCESS_MESSAGE": "பாஸ்வேர்டை மீட்டமைக்கும் வழிமுறைகள் கொண்ட ஈமெயில் ஏஜெண்ட்டுக்கு அனுப்பப்பட்டுள்ளது",
        "SUCCESS_MESSAGE": "ஏஜென்ட் பாஸ்வேர்டு வெற்றிகரமாக மீட்டமைக்கப்பட்டது",
        "ERROR_MESSAGE": "வூட் சர்வருடன் இணைக்க முடியவில்ல, மீண்டும் முயற்சிக்கவும்"
      }
    },
    "SEARCH_PLACEHOLDER": "Search agents...",
    "NO_RESULTS": "No agents found matching your search",
    "SEARCH": {
      "NO_RESULTS": "No results found."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "None",
      "TITLE": {
        "AGENT": "Select agent",
        "TEAM": "Select team"
      },
      "LIST": {
        "NONE": "None"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "No agents found",
          "TEAM": "No teams found"
        },
        "PLACEHOLDER": {
          "AGENT": "Search agents",
          "TEAM": "Search teams",
          "INPUT": "Search for agents"
        }
      }
    }
  }
}
